import type { AgentApiCandidateFormAnswersIndex } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';

export default function useFetchCandidateFormAnswers() {
  return useQuery({
    queryKey: ['candidate_form_answers'],
    queryFn: async () => {
      const response = await fetch('/agent/api/candidate_forms/candidate_form_answers.json');

      if (!response.ok) {
        throw new Error(`Failed to fetch candidate form answers: ${response.status}`);
      }

      const data: AgentApiCandidateFormAnswersIndex = await response.json();
      return data;
    },
  });
}
